export default "__VITE_ASSET__CSBGu3mC__"